export const FETCH_REPORTED_POST_REQUEST = 'FETCH_REPORTED_POST_REQUEST';
export const FETCH_REPORTED_POST_SUCCESS = 'FETCH_REPORTED_POST_SUCCESS';
export const FETCH_REPORTED_POST_ERROR   = 'FETCH_REPORTED_POST_ERROR';

export const DELETE_REPORTED_POST_REQUEST = 'DELETE_REPORTED_POST_REQUEST';
export const DELETE_REPORTED_POST_SUCCESS = 'DELETE_REPORTED_POST_SUCCESS';
export const DELETE_REPORTED_POST_ERROR   = 'DELETE_REPORTED_POST_ERROR';